import styled from 'styled-components'

import { Input as InputBase } from '@icontainers/design-system/dist/molecules/Input'
import BackdropBase from '@mui/material/Backdrop'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Wrapper = styled.div`
    position: relative;
`

export const Title = styled.div`
    color: ${(props) => props.theme.color.black};
    ${(props) => props.theme.typo.bodyL}
    ${(props) => props.theme.fontWeight.medium};
    line-height: 180%;
    margin-bottom: 5px;
`

export const Description = styled.div`
    color: ${(props) => props.theme.color.g500};
    ${(props) => props.theme.typo.bodyM}
    line-height: 180%;
`

export const Link = styled(LinkBase)`
    display: block;
    text-decoration: none;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${(props) => props.theme.color.g200};

    &:hover {
        ${Title}, ${Description} {
            text-decoration: underline;
        }
    }
`

export const ResultsWrapper = styled.div`
    position: absolute;
    max-height: 400px;
    overflow: auto;
    z-index: 1;
    background-color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.boxShadow.level4};
    width: 100%;
    padding: 30px;
    border-radius: 0px 0px 10px 10px;

    > ${Link}:last-child {
        border-bottom: 0px;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }
`

export const Backdrop = styled(BackdropBase)<{ $layerIndex: number }>`
    &.MuiBackdrop-root {
        z-index: ${(props) => props.$layerIndex};
        background: transparent;
    }
`

export const Input = styled(InputBase)`
    z-index: 1;
`
